var map = {
	"./1280_300×200.jpg": 2846,
	"./1980_300×200.jpg": 801,
	"./300_300×200.jpg": 9146,
	"./3280_300×200.jpg": 4512,
	"./6480_300×200.jpg": 5661,
	"./680_300×200.jpg": 2035,
	"./Elf_ButterflyElvess_Nest.png": 4664,
	"./Elf_Pegasus_Nest.png": 6025,
	"./Elves_Bigfoot_0.png": 5325,
	"./Elves_Dragonfly_0.png": 715,
	"./Icon_64_AcceleratorCard_01.png": 7482,
	"./Icon_64_Bearing_01.png": 4961,
	"./Icon_64_Bread_01.png": 8245,
	"./Icon_64_CageKey_01.png": 4312,
	"./Icon_64_Dust_01.png": 5619,
	"./Icon_64_Exp_Modify_01.png": 2501,
	"./Icon_64_Gear_01.png": 9724,
	"./Icon_64_GodEXP_1_01.png": 2918,
	"./Icon_64_IronRes_01.png": 9091,
	"./Icon_64_MeatRes_01.png": 7808,
	"./Icon_64_PartsExp_01.png": 174,
	"./Icon_64_PropGem_01.png": 8747,
	"./Icon_Chest_03.png": 3779,
	"./Icon_SkinCoin_02.png": 8105,
	"./Icon_SkinCoin_03.png": 6928,
	"./MapItem_FruitTree_2.png": 7183,
	"./MapItem_MagicEgg_02.png": 8283,
	"./MapItem_MagicEgg_04.png": 8954,
	"./MapItem_MagicWell_01.png": 3853,
	"./MapItem_Magic_Coin_4.png": 5678,
	"./MapItem_Magic_Coin_5.png": 5175,
	"./MapItem_NaturalTemple_1.png": 5185,
	"./MapItem_NaturalTemple_2.png": 4917,
	"./MapItem_PurificationBall_5.png": 7784,
	"./MapItem_PurificationFlower_10.png": 6936,
	"./MapItem_PurificationFlower_3.png": 7616,
	"./MapItem_PurificationFlower_6.png": 2157,
	"./MapItem_PurificationFlower_9.png": 5562,
	"./MapItem_PurificationTree_2.png": 828,
	"./MapItem_RandomEgg_1.png": 9362,
	"./MapItem_RandomEgg_2.png": 329,
	"./MapItem_RandomEgg_3.png": 2208,
	"./MapItem_Stone_2.png": 3626,
	"./MapItem_UniversalEgg_02.png": 1833,
	"./MapItem_UniversalEgg_03.png": 7632,
	"./MapItem_Yggdrasil_2.png": 219,
	"./Mapltem_Sanctuary_01.png": 6941,
	"./Mystery_Egg_1_Nest.png": 9664,
	"./Mystery_Egg_2_Nest.png": 9417,
	"./Mystery_Egg_3_Nest.png": 1538,
	"./UI_Boost_WR.png": 4838,
	"./UI_Di_Elves_FlowerDragon_1.png": 7247,
	"./UI_Di_Elves_GrassDragon_1.png": 7132,
	"./UI_Di_Elves_HolyDragon_1.png": 1648,
	"./UI_Di_Elves_RuneDragon_1.png": 1889,
	"./UI_Di_Item_Energy_3.png": 9423,
	"./UI_Di_Item_Energy_4.png": 1392,
	"./UI_Di_Item_Energy_X.png": 4844,
	"./UI_Di_Item_Windmill_5.png": 5225,
	"./UI_Di_Item_Windmill_6.png": 1218,
	"./UI_Di_Item_WonderStone_3.png": 8679,
	"./UI_Di_Item_WonderStone_4.png": 6536,
	"./UI_Diamond100.png": 32,
	"./UI_Diamond20.png": 6315,
	"./UI_Diamond2000.png": 8776,
	"./UI_Diamond250.png": 8244,
	"./UI_Diamond4500.png": 6708,
	"./UI_Diamond600.png": 4039,
	"./UI_Diamond_1.png": 973,
	"./UI_Diamond_2.png": 9766,
	"./UI_Diamond_3.png": 8783,
	"./UI_Diamond_4.png": 6560,
	"./UI_Diamond_5.png": 2809,
	"./UI_Dragon_Island_1.png": 486,
	"./UI_Dragon_Island_2.png": 8045,
	"./UI_Dragon_Island_3.png": 564,
	"./UI_Dragon_Island_4.png": 6827,
	"./UI_Elder_Tree_4.png": 9015,
	"./UI_Elf_Banshee_Nest.png": 5882,
	"./UI_Elf_Moonwolf_Nest.png": 2059,
	"./UI_Fairy_Gift_Pack_1.png": 6021,
	"./UI_Fairy_Gift_Pack_2.png": 5646,
	"./UI_Fairy_Gift_Pack_3.png": 1431,
	"./UI_Fairy_Gift_Pack_4.png": 1816,
	"./UI_MapItem_Gem_4.png": 2011,
	"./UI_MapItem_Gem_6.png": 1801,
	"./UI_Shop_Chest_Diamond_1.png": 4402,
	"./UI_Shop_Chest_Diamond_2.png": 2585,
	"./UI_Shop_Chest_Diamond_3.png": 2032,
	"./UI_Shop_Chest_Diamond_4.png": 8527,
	"./UI_Shop_Chest_Diamond_5.png": 9510,
	"./UI_Shop_Chest_Diamond_6.png": 749,
	"./UI_Special_Offer_1-1.png": 5909,
	"./UI_Special_Offer_1.png": 6755,
	"./UI_Special_Offer_2-1.png": 1654,
	"./UI_Special_Offer_2.png": 9896,
	"./UI_Special_Offer_3-1.png": 4555,
	"./UI_Special_Offer_3.png": 9841,
	"./UI_Special_Offer_4-1.png": 2180,
	"./UI_Special_Offer_4.png": 3726,
	"./ann_0001.png": 807,
	"./c.png": 5891,
	"./dailypack.png": 2672,
	"./diamond.png": 1704,
	"./ld_0006.png": 177,
	"./ld_0007_t.png": 2989,
	"./money.png": 3840,
	"./paper.png": 2206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5872;